import { render, staticRenderFns } from "./ErrorRenderer.vue?vue&type=template&id=22fb2032&scoped=true&"
import script from "./ErrorRenderer.vue?vue&type=script&lang=js&"
export * from "./ErrorRenderer.vue?vue&type=script&lang=js&"
import style0 from "./ErrorRenderer.vue?vue&type=style&index=0&id=22fb2032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fb2032",
  null
  
)

export default component.exports